export const CLIENT_ID =
    "1064115497372-pdg05barjshr9dfbv3gqu0ceeohu7nrv.apps.googleusercontent.com";
//export const ApiReqBaseUrl = "https://api.staging.hotelsriver.com";
export const BaseUrl = process.env.REACT_APP_BASE_URL || "https://hotelsriver.com";
export const ApiReqBaseUrl = process.env.REACT_APP_API_URL;
export const GoogleMapSecretKey = "AIzaSyDhxJv4pkO852UnQgOEPqKQk-_UxJmE2AY"; // Google map Secret api key
export const IS_DEV = process.env.REACT_APP_IS_DEV === "1";
